import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollectionGroup, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore'

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(private afs: AngularFirestore) { }

  getProjects() {
    return this.afs.collectionGroup<AngularFirestoreCollectionGroup<any>>('proyectos');
  }

  getBanner() {
    return this.afs.doc<AngularFirestoreDocument<any>>('banner/1');
  }

  setVisits(count: number) {
    return this.afs.doc('banner/1').update({
      visits: count + 1
    });
  }

  getRedes() {
    return this.afs.collectionGroup<AngularFirestoreCollectionGroup<any>>('redes');
  }

  getCertificados() {
    return this.afs.collectionGroup<AngularFirestoreCollectionGroup<any>>('certificados');
  }
}
